import React from 'react';
import { Company } from '../../dashboard_user/types';
import { ProcessingStep } from './ProcessingStep';

interface EnrichmentOverviewStepProps {
  company: Company;
  onRerun: () => void;
  onBack: () => void;
}

/**
 * Rendered when a partner lands on the enrichment flow with a company that
 * has already been enriched (`enrichment_score > 0`). Reuses `ProcessingStep`
 * in its "completed" state with a synthetic session to display the existing
 * score and surface the primary "Re-run Enrichment" + "Back to Dashboard"
 * actions.
 */
export const EnrichmentOverviewStep: React.FC<EnrichmentOverviewStepProps> = ({
  company,
  onRerun,
  onBack,
}) => {
  return (
    <ProcessingStep
      enrichmentCompleted={true}
      processingAfterSubmit={false}
      processingMessage=""
      session={{
        session_id: '',
        company_id: company.id || 0,
        status: 'completed',
        try_count: 0,
        current_score: company.enrichment_score || 0,
        created_at: company.last_enrichment_at || new Date().toISOString(),
        last_activity_at: company.last_enrichment_at || new Date().toISOString(),
        can_finalize: false,
        progress_percent: 100,
      }}
      sessionError={null}
      checkingStatus={false}
      loadingForm={false}
      primaryActionLabel="Re-run Enrichment"
      secondaryActionLabel="Back to Dashboard"
      onBack={onBack}
      onViewSession={() => {}}
      onSkipEnrichment={() => {}}
      onCancelSession={() => {}}
      onLoadForm={onRerun}
      onSkipToDashboard={async () => {
        onBack();
      }}
    />
  );
};
